import { TbCreditCard, TbLock, TbSettings } from "react-icons/tb";

export const CardContextActions = () => {
  const items = [
    { label: "Bloquear", icon: TbLock, comingSoon: true },
    { label: "Limites", icon: TbSettings, comingSoon: true },
    { label: "2ª via", icon: TbCreditCard, comingSoon: true },
  ];

  return (
    <div className="cartoes-action-row">
      {items.map(({ label, icon: Icon, comingSoon }) => (
        <button
          key={label}
          type="button"
          className="cartoes-action-btn"
          disabled={comingSoon}
        >
          <Icon className="h-3.5 w-3.5 shrink-0" />
          <span>{label}</span>
          {comingSoon && <span className="cartoes-action-btn__soon">Soon</span>}
        </button>
      ))}
    </div>
  );
};
